import { z } from 'zod';

// Values match the backend API enum — preserve casing
export const stageKeySchema = z.enum(['INTRODUCAO', 'DESENVOLVIMENTO', 'CONCLUSAO']);

export type StageKey = z.infer<typeof stageKeySchema>;

export type StageStatus = 'past' | 'current' | 'upcoming';

// Fixed pedagogical order — always compose selected stages in this sequence
export const STAGE_ORDER = ['INTRODUCAO', 'DESENVOLVIMENTO', 'CONCLUSAO'] as const satisfies readonly StageKey[];

export type StageItem = {
  id: StageKey;
  nome: string;
  descricao: string;
};
